/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTextareaProps } from './type';

export const textareaDefaultProps: TdTextareaProps = {
  allowInputOverMax: false,
  autofocus: false,
  autosize: false,
  bordered: false,
  disabled: undefined,
  indicator: false,
  layout: 'horizontal',
  placeholder: undefined,
  readonly: false,
};
